import settings from "../config/settings";

export const getHelpUrl = (article: number) => {
  return `${settings.helpUrl}/${article}`;
};

